

let contract = {};

function logInsightsEvent(eventName, propertiesObject){
	if(window.appInsights &&
		window.appInsights.config &&
		window.appInsights.config.instrumentationKey &&
		window.appInsights.trackEvent) {
		const eventObj = {
			name: eventName,
			properties: propertiesObject
		};
		window.appInsights.trackEvent(eventObj);
	}
}

contract = {
	logInsightsEvent: logInsightsEvent
};

export default contract;
